import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/settings/publicity/store/publicitySlice/initialState.ts'

const publicitySlice = createSlice({
  name: 'publicity',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const publicityActions = publicitySlice.actions
export const { reducer: publicityReducer } = publicitySlice